import { render, staticRenderFns } from "./DuplicatedPatientSelector.vue?vue&type=template&id=57b356b6&scoped=true&"
import script from "./DuplicatedPatientSelector.vue?vue&type=script&lang=ts&"
export * from "./DuplicatedPatientSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicatedPatientSelector.vue?vue&type=style&index=0&id=57b356b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b356b6",
  null
  
)

export default component.exports